import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import noImage from '../../../assets/images/no-image.png';
import { checkStatus, shortenandHoverString } from '../../helper';
import '../../../Pages/Library/ColorLibary/colourLib.css';

const ifImported = (isImport, handleImportLib, element, t) => {
  return (
    isImport && (
      <li>
        <button
          title={t('COLOUR_LIBRARY_GROUP_CARD.ADD_UPDATE_LIBRARY')}
          aria-label={t('COLOUR_LIBRARY_GROUP_CARD.ADD_UPDATE_LIBRARY')}
          type="button"
          className="btn p-0"
          onClick={() => handleImportLib(element._id)}
        >
          <i className="icon-add_to_library" />
        </button>
      </li>
    )
  );
};

function ColourLibraryGroupCard({
  item,
  index,
  onCheck,
  onDelete,
  editeble,
  selectedIds,
  isImport,
  handleLinkAge,
  handleImportLib,
  isSupplierLoggedIn,
  isProductArchived,
  ColurAddEditAccess,
  ColourDeleteAccess,
  subBrandAccess,
}) {
  const [element, setElement] = useState(null);
  const history = useHistory();
  const { t } = useTranslation('common');
  const [showCreatedBy, setShowCreatedBy] = useState(false);
  const isChecked = selectedIds.filter((val) => val === item._id).length > 0;

  useEffect(() => {
    // effect
    const value = item ? { ...item } : null;
    setElement(value);
  }, [item]);

  const isOldImage = () => {
    return element.image.includes('data:image/png;base64') ? element.image : `${element.image}`;
  };

  return (
    <div id="accordion" className="col-lg-3" key={index}>
      <div className="common-listing-card card mt-5 mb-16">
        <div className="card-header">
          {!isSupplierLoggedIn && !isProductArchived && (
            <ul className="card-header-icon">
              {ColurAddEditAccess || ColourDeleteAccess ? (
                <li>
                  <div className="common-checkbox">
                    <input
                      onChange={(e) => {
                        onCheck(e, item._id, index);
                      }}
                      name={`check_${index}`}
                      id={`check_${index}`}
                      type="checkbox"
                      checked={isChecked}
                    />
                    <label htmlFor={`check_${index}`} className="chklabel" />
                  </div>
                </li>
              ) : (
                ''
              )}
              {ifImported(isImport, handleImportLib, element, t)}
              {editeble && ColurAddEditAccess && (
                <li>
                  <button
                    type="button"
                    title={t('COLOUR_LIBRARY_GROUP_CARD.EDIT')}
                    aria-label={t('COLOUR_LIBRARY_GROUP_CARD.EDIT')}
                    className="btn btn-action-icon m-0"
                    onClick={() => element?._id && history.push(`/libraries/colour-group/edit/${element._id}`)}
                  >
                    <i className="icon-Edit-1" />
                  </button>
                </li>
              )}
              {ColourDeleteAccess && (
                <li className="delete-colour">
                  <button
                    type="button"
                    title={t('COLOUR_LIBRARY_GROUP_CARD.DELETE')}
                    aria-label={t('COLOUR_LIBRARY_GROUP_CARD.DELETE')}
                    className="btn btn-action-icon m-0"
                    onClick={() => {
                      onDelete(element._id);
                    }}
                  >
                    <i className="icon-Delete" />
                  </button>
                </li>
              )}
              {isImport && (
                <li>
                  <button
                    className="btn btn-action-icon m-0"
                    type="button"
                    title={t('COLOUR_LIBRARY_GROUP_CARD.LINKAGE')}
                    aria-label={t('COLOUR_LIBRARY_GROUP_CARD.LINKAGE')}
                    onClick={() => handleLinkAge(element._id)}
                  >
                    <i className="icon-link" />
                  </button>
                </li>
              )}
            </ul>
          )}
          <div className="image-detail">
            <div
              className="card-image-preview"
              style={{
                backgroundImage: `url(${element?.image ? isOldImage() : noImage})`,
              }}
            />
            <span
              className="big-image"
              style={{
                backgroundImage: `url(${element?.image ? isOldImage() : noImage})`,
              }}
            />
          </div>
        </div>
        <div className="card-body">
          <div onClick={() => setShowCreatedBy(!showCreatedBy)}>
            <h4 className="title">{element?.name ? shortenandHoverString(element?.name, 20) : ''}</h4>
            <ul className="card-ul">
              <li>
                <strong>{t('COLOUR_LIBRARY_GROUP_CARD.GROUP_DESCRIPTION')} </strong>
                {element?.description && shortenandHoverString(element.description, 40)}
              </li>
              <li>
                <strong>{t('COLOUR_LIBRARY_GROUP_CARD.BRAND')} </strong>
                {element?.brand}
              </li>
              {subBrandAccess && (
                <li>
                  <strong>{t('COLOUR_LIBRARY_GROUP_CARD.SUB_BRAND')} </strong>
                  {element?.subBrand}
                </li>
              )}
              <li>
                <strong>{t('COLOUR_LIBRARY_GROUP_CARD.SEASON_YEAR')} </strong>
                {element?.season && element?.year && `${element.season} ${element.year}`}
              </li>
            </ul>
          </div>
          {showCreatedBy && (
            <div>
              <ul className="card-ul">
                <li>
                  <strong>{t('COLOUR_LIBRARY_GROUP_CARD.CREATED_BY_DATE_TIME')} </strong>
                  {element?.createdBy && (
                    <span>
                      {element.createdBy}
                      {element.createdAt && `${' '} | ${' '}`}
                      {element.createdAt && moment(element.createdAt).format('DD-MMMM-YYYY, HH:mm:ss a')}
                    </span>
                  )}
                </li>
                <li>
                  <strong>{t('COLOUR_LIBRARY_GROUP_CARD.MODIFIED_BY_DATE_TIME')} </strong>
                  <span>
                    {element?.modifiedBy &&
                    element?.lastModifiedAt &&
                    element?.createdAt &&
                    moment(element.lastModifiedAt).isAfter(moment(element.createdAt)) ? (
                      <>
                        {element.modifiedBy}
                        {element.lastModifiedAt && `${' '} | ${' '}`}
                        {element.lastModifiedAt && moment(element.lastModifiedAt).format('DD-MMMM-YYYY, HH:mm:ss a')}
                      </>
                    ) : (
                      <>
                        {element.createdBy}
                        {element.createdAt && `${' '} | ${' '}`}
                        {element.createdAt && moment(element.createdAt).format('DD-MMMM-YYYY, HH:mm:ss a')}
                      </>
                    )}
                  </span>
                </li>
              </ul>
            </div>
          )}
        </div>
        {isImport ? <div className={`status ${checkStatus(element)}`} /> : null}
      </div>
    </div>
  );
}

export default ColourLibraryGroupCard;
